import { NeedResponse } from '../../types';
import { AppFixture } from '../types';

/**
 * - Remove the `seed` need from the array of returned needs.
 * - Sets the default of the `total` need to 123 and updates its help_text.
 * - Sets the `seed` param to always be 456.
 * - Add a SQL field with a key of `query`.
 */

const sqlNeed: NeedResponse = {
  key: 'query',
  help_text:
    'This need has been appended via fixtures and uses the custom `sql` field type.',
  type: 'sql',
};

const fixture: AppFixture = {
  fixtures: {
    needs: (needs) => {
      const filtered = needs.filter(({ key }) => key !== 'seed');
      filtered.push(sqlNeed);
      filtered.forEach((need) => {
        if (need.key === 'total') {
          need.default = 123;
          need.help_text =
            'This need has been updated via fixtures to have a default value of 123.';
          need.help_text_html = `<p><strong>${need.help_text}</strong></p>`;
        }
      });
      return filtered;
    },
    params: (params) => ({ ...params, seed: 456 }),
  },
};

export default fixture;
